import * as React from 'react'
import { GymnastContextType } from '../types'
import defaults from '../defaults'

export default React.createContext<GymnastContextType>(defaults)
